import { Inject, Injectable, InjectionToken } from '@angular/core';
import { SelectItem } from '@psei/ng/api';
import { ConfirmationDocument } from 'projects/ppb-shared-library/src/lib/models/account.model';
import { map } from 'rxjs/operators';
import { DictionaryCategory } from '../models/dictionary.model';
import { SharedApiService } from './interfaces/shared-api.service';
import { SelectItemService } from './select-item.service';

export const PAGE_TITLE = new InjectionToken<string>('confirmation-documents.path');

@Injectable({ providedIn: 'root' })
export class ConfirmationDocumentService {

  private documents: Map<string, string[]>;
  private factorItems: SelectItem[];


  constructor(
    private api: SharedApiService,
    @Inject(PAGE_TITLE) private servicePath: string,
    private itemService: SelectItemService,
  ) {
    this.init();
    this.factorItems = this.itemService.getSelectItems(DictionaryCategory.CONFIRMATION_FACTOR);
  }

  factorsForDocument(documentId: string): SelectItem[] {
    return this.documents?.get(documentId)
      .map(factorId => this.factorItems.find(factorItem => factorItem.id === factorId))
      .filter(item => !!item);
  }

  updateConfirmationDocuments(formValues: any): any {
    const selectedDocuments = formValues.documents as string[];
    if (selectedDocuments) {
      formValues.documents = selectedDocuments.map(document => {
        const factors: string[] = formValues[`factors_${document}`];
        delete formValues[`factors_${document}`];
        return { 'document': document, 'factors': factors };
      });
      return formValues;
    }
    return formValues;
  }

  private init(): void {
    this.api.get<ConfirmationDocument[]>(this.servicePath)
      .pipe(
        map(documents => {
          const docEntries = documents.map(document => [document.document, document.factors] as [string, string[]]);
          return new Map<string, string[]>(docEntries);
        })
      ).subscribe(documentsMap => this.documents = documentsMap);
  }
}
